import * as React from "react";
import Svg, { Path } from "react-native-svg";

const Q = (props) => (
  <Svg
    width={166}
    height={101}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M27.26 95.117c-8.598-3.957-15.294-9.664-20.012-17.121C2.531 70.539.172 61.788.172 51.668c0-10.121 2.359-19.024 7-26.862 4.642-7.837 11.11-13.925 19.252-18.262S43.697 0 53.742 0C63.785 0 72.84 2.207 80.906 6.544c8.066 4.337 14.458 10.425 19.099 18.262 4.642 7.838 7.001 16.817 7.001 26.861 0 5.099-1.141 10.197-3.576 15.22-2.359 5.021-5.327 9.13-8.751 12.25l68.027-.456c2.892 0 4.033 3.728 1.598 5.326l-23.969 15.447a10.083 10.083 0 0 1-5.327 1.522H57.318c-11.49.076-21.459-1.902-30.057-5.86ZM65.613 72.82c3.576-1.902 6.392-4.717 8.446-8.37 2.055-3.652 3.12-7.913 3.12-12.783 0-7.23-2.206-13.089-6.696-17.426-4.413-4.337-10.044-6.468-16.74-6.468-6.773 0-12.48 2.207-16.97 6.468C32.284 38.58 30 44.362 30 51.667c0 4.947 1.066 9.208 3.12 12.784 2.055 3.577 4.946 6.392 8.523 8.37 3.576 1.979 7.609 2.892 12.022 2.892 4.414 0 8.37-.99 11.947-2.891Z"
      fill="#fff"
    />
  </Svg>
);

export default Q;
